import { CONSTANTS } from '../attributes/BatteryAlerts';
import BatteryAlertsEqualsComparator from './BatteryAlertsEqualsComparator';
import AliasEqualsSelector from '../../attributes/filters/AliasEqualsSelector';
const options = [{
  name: 'End of Life',
  value: CONSTANTS.END_OF_LIFE
}, {
  name: 'Low Voltage',
  value: CONSTANTS.LOW_VOLTAGE
}, {
  name: 'Low Battery',
  value: CONSTANTS.LOW_BATTERY
}];
export default AliasEqualsSelector.create(BatteryAlertsEqualsComparator, options);